import React from 'react';
import '../components/Polymathy.css';

const WorkforceSolutionsPage = () => {
  const workforceComparisons = [
    {
      feature: 'Who Performs the Work?',
      insourcing: "Client company's direct employees.",
      coSourcing: "Joint team of client's staff and vendor's staff.",
      outsourcing: "External vendor's employees."
    },
    {
      feature: 'Management Control',
      insourcing: 'Full control retained by the client.',
      coSourcing: 'Shared control and responsibility.',
      outsourcing: 'Control is transferred to the vendor.'
    },
    {
      feature: 'Operational Risk',
      insourcing: 'Fully absorbed by the client.',
      coSourcing: 'Shared between the client and the vendor.',
      outsourcing: 'Primarily the vendor\'s responsibility.'
    },
    {
      feature: 'Primary Goal',
      insourcing: 'Retain expertise, maximize control.',
      coSourcing: 'Supplement internal staff, access specialized skills.',
      outsourcing: 'Reduce costs, increase flexibility, focus on core functions.'
    },
    {
      feature: 'Staff Relationship',
      insourcing: 'Direct employees (fixed cost).',
      coSourcing: 'Mixed (direct staff + contractual/consulting).',
      outsourcing: 'Contractual (variable cost).'
    }
  ];

  return (
    <section className="polymathy-section">
      <div className="container">
        <div className="polymathy-header">
          <h2 className="section-title center">STRATEGIC TALENT & WORKFORCE SOLUTIONS</h2>
          <div className="title-underline center"></div>
          <p className="polymathy-subtitle">
            Co-sourcing and Outsourcing Options
          </p>
        </div>

        <div className="workforce-section">
          <div className="workforce-table">
            <div className="workforce-header">
              <span>Feature</span>
              <span>In-house Sourcing (Insourcing)</span>
              <span>Co-sourcing</span>
              <span>Outsourcing</span>
            </div>
            {workforceComparisons.map((item) => (
              <div key={item.feature} className="workforce-row">
                <div className="workforce-feature">{item.feature}</div>
                <div className="workforce-cell">{item.insourcing}</div>
                <div className="workforce-cell">{item.coSourcing}</div>
                <div className="workforce-cell">{item.outsourcing}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkforceSolutionsPage;

